import useSWR from 'swr';
import { APIError, ResponseWrapper } from '@tlx/astro-shared';
import { dateUtil } from '@Util/date';
import { computeUrl } from '@Util/api';
import { APIUrls } from '@Util/urls.ts';

export const SALARY_PAY_IN_ADVANCE = {
    SUGGEST_NOTHING: 0,
    SUGGEST_TURN_ON: 1,
    SUGGEST_TURN_OFF: 2,
} as const;

export function useSuggestChangingPayInAdvance(selectedPeriod: Date) {
    const apiParams = new URLSearchParams();
    // invalid date is truthy, so we check that it is a valid date
    if (selectedPeriod && !isNaN(selectedPeriod.getTime())) {
        apiParams.append('period', dateUtil.formatDate(selectedPeriod, 'no'));
    }
    const { data } = useSWR<ResponseWrapper<number>, APIError>(computeUrl(APIUrls.SUGGEST_PAY_IN_ADVANCE, apiParams), {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    return data?.value ?? SALARY_PAY_IN_ADVANCE.SUGGEST_NOTHING;
}
